<template>
<article>
  <section id="doc" class="section" v-if="posts">
  <header>
    <h1 id="title">{{title}}</h1>
  </header>
  
  <div id="index" class="content">
    <div v-for="post in posts">
        <span>{{Date.parse(post.date)/1000 | formatDate}}</span>
        <router-link :to="curpath+'/'+post.slug">
          <figure v-if="post.jetpack_featured_media_url" class="thumb">
            <img class="thumb" :src="post.jetpack_featured_media_url"/>
          </figure>
          <h2 class="is-title" v-html="post.title.rendered"/>
        </router-link>
    </div>
  </div>
  <footer>
  </footer>
  <index-launcher class="launcher"></index-launcher>
  </section>
  <section id="doc" v-else>
    <div id="body" class="content">
      Sorry - this is not the index your are looking for...
    </div>
    <index-launcher class="launcher"></index-launcher>
  </section>
</article>

</template>

<script>
import IndexLauncher from '@/components/IndexLauncher'

const INDICES = {
  slug: { type: 'post', title: 'Pixxi Journal', cms: 'pixxijournal.wordpress.com' },
  journal: { type: 'post', title: 'Pixxi Journal', cms: 'shirleyesque.wordpress.com'},
  doc: { type: 'page', title: 'Documentation List', cms: 'pixxijournal.wordpress.com' },
}

export default {
  name: 'SlugIndexPage',
  components: {
    IndexLauncher,
  },
  metaInfo() { return {
    title: this.title,
    meta: {} //this.ogMeta,
  }},
  data() { return {
    title: 'eh?',
    posts: [],
    curpath: '',
  }},
  computed: {
  },
  methods: {
    maybeReload: function(path) {
      if (path != this.curpath) {
        this.curpath = path
        this.reload(path)
      } else {
        console.log('drop duplicate reload', path)
      }
    },
    reload: function(path) {
      path = path.replace(/\/$/, '') //remove trailing / (prerendered case)
      path = path.replace(/^\//, '') //remove leading /
      this.meta = {}
      this.title = INDICES[path].title
      const type = INDICES[path].type
      const site = INDICES[path].cms
      var posturi = 'https://public-api.wordpress.com/wp/v2/sites/' + site +'/posts'
          + '?type=' + type + '&_fields=title,slug,date,categories,jetpack_featured_media_url'
      console.log('RELOAD:', path, posturi)
      this.$http.get(posturi).then( (rsp) => {
        console.log('RELOAD:', rsp.body)
        this.posts = rsp.body
      }).catch( (err) => {
        console.error('## ERROR\n' + err)
      })
    },
    extractSlug: function(url) {
      var path = url.replace(/\/(\?.*)?$/,'').split('/')
      return path ? path[path.length-1] : ''
    },
    postProcess: function() {
      //send relative links via router
      var links = document.querySelectorAll('#doc a')
      if (links) {
        var absRE = new RegExp('http://|https://|mailto:|//', 'i');
        for (var i=0; i<links.length; ++i) {
          var href = links[i].getAttribute('href')
          console.log('check href=',href)
          var router = this.$router
          if (href && !absRE.test(href)) {
            links[i].onclick = function(ev) {
              ev.preventDefault()
              router.push(ev.currentTarget.getAttribute('href'))
            }
          } else {
            links[i].setAttribute('target', links[i].getAttribute('target') || '_blank')
          }
        }
      }
    },
  },
  watch: {
    content: function() {
      this.$nextTick(function() {
        if (this.$route.hash) {
          var anchors = document.getElementsByName(this.$route.hash.slice(1))
          if (anchors) {
            anchors[0].scrollIntoView();
          }
        }
        this.postProcess();
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.maybeReload(to.path))
  },
  beforeRouteUpdate(to, from, next) {
    // re-using component for another doc page
    this.maybeReload(to.path)
    next()
  },
  mounted() {
    //for pre-rendered page
    this.maybeReload(this.$route.path)
  }

}
</script>

<style scoped>
section {
    margin-top: 2em;
    margin-bottom: 2em;
}
.fill-height {
    min-height: 50vh;
}
#summary {
    color: #363636;
    margin: 1ex 2em 1em 2em;
}
.tag.draft {
    color: black;
    background-color: yellow;
}

figure.thumb {
  padding: 1ex;
  background-color: white;
  border: thin silver solid;
  max-width: 10em;
  border: thin solid silver;
  float: left;
  margin: 1ex 2ex 1ex 0;
}

#doc {
  max-width: 120ex;
  margin: auto;
}
#doc header {
  -background-color: #363636;
  margin: 2em 0 2em 0;
  padding: 1ex;
  border-bottom: .5ex solid black;
}

#doc header h1 {
  font-size: 2.5em;
  font-weight: bold;
  color: black;
}
#doc header #meta {
  display: flex;
  justify-content: space-between;
}
#doc header #meta #tags {
  margin-left: auto;
}
#doc #float-clearer { clear: both; }

#doc footer #related {
    padding-left: 3em;
}
#doc footer #related h2 {
    font-size: 120%;
}
#doc footer #related .item{
    padding-left: 2em;
    padding-bottom: .5ex;
}
#doc footer #related .thumb {
    max-width: 5em;
    max-height: 3em;
    vertical-align: middle;
    margin-right: 1ex;
}
.launcher { margin: 2em 0; }
</style>




// WEBPACK FOOTER //
// src/components/SlugIndexPage.vue